import { Injectable, ViewChild } from '@angular/core';
import { ApiService } from "../../../services/api.service";
import { StorageService } from "../../../services/storage/storage.service";

@Injectable({
  providedIn: 'root'
})
export class GetOpsService {
  constructor(
    public api: ApiService,
    public storage: StorageService
  ) { }

  async upDateAllCred(updateCreds) {
    /* Actualiza los creditos existentes */
    const actualArr = this.api.allEncCredits.map(cred => updateCreds.find(updateCred => updateCred.NumSol === cred.NumSol) || cred); 
    /* Determina nuevos creditos */
    const newCreds = updateCreds.filter(updateCred => !this.api.allEncCredits.some(cred => updateCred.NumSol === cred.NumSol))
    /* Se actualiza todo el array */
    this.api.allEncCredits = actualArr.concat(newCreds);
    console.log('updateCreds: ', updateCreds);
    console.log('newCreds: ', newCreds);
    this.api.presentToast(`${newCreds.length} créditos nuevo(s) y ${updateCreds.length - newCreds.length} céditos actualizado(s)`, 'primary', 4000);
    this.api.filtEncCred = this.api.clonar(this.api.allEncCredits);

    await this.storage.save(this.api.allEncCredits, `allOp-${this.api.user.Usuario}`);
  }

  allOpTimeStamp:any;
  async getRunCredits2(enMsg = true, msg = 'Actualizando solicitudes en proceso...') {
    console.log(msg);
    const body = {
      date: this.api.formatDate(this.allOpTimeStamp)
    }
    console.log('body get runCredits2: ', body);
    await this.api.req('post','getruncredits3',body,msg,enMsg)
      .then( async (res:any) => {
        res.creditos = this.api.filtPensionados(res.creditos);

        res.creditos.forEach(credito => {

          let empresa = this.api.empresas1.find(empresa => empresa.IdEmpresa==credito.IdEmpresa);

          credito.IdEmpresa = empresa.Nombre.trim();

          if(credito.IdEstado==2 && credito.AprobadoRH==0){
            credito.IdEstado='8'
          }
          let estado = this.api.estados.find(estado => estado.IdEstado==credito.IdEstado) 
          console.log('estado: ',estado);
          credito.IdEstado = estado.Descripcion

        });
        this.allOpTimeStamp = res.timeStamp - (3600 * 1000 * 5);
        if (res.creditos.length > 0) {
          await this.upDateAllCred(res.creditos);
          this.updateFilter(this.api.busqueda1.trim());
        } else {
          this.api.presentToast('Estas al día, nada nuevo','primary',4000);
        }
        await this.storage.save(this.allOpTimeStamp, `allOpTimeStamp-${this.api.user.Usuario}`);
      })
      .catch((err) => {
        this.api.presentAlert('Error', 'Al cargar solicitudes en proceso', JSON.stringify(err));
      })
    return 1;
  }

  updateFilter(event) {
    const val = event.toLowerCase().trim();
    this.api.filtEncCred = this.api.allEncCredits.filter((d) => {
      return (
           d.Cedula.toLowerCase().indexOf(val) !== -1
        || d.NombreCompleto.toLowerCase().indexOf(val) !== -1
        || d.NumSol.toString().indexOf(val) !== -1
        || d.IdEmpresa.toLowerCase().indexOf(val) !== -1
        || d.IdEstado.toLowerCase().indexOf(val) !== -1
        || d.TipoCredito.toLowerCase().indexOf(val) !== -1
        || !val);
    });
    this.filtEncCreditEstados(this.api.filtEncCred);
  }

  filtEncCreditEstados(filtEncCredits){
    let tempFilt=[];
    this.api.estadosSelectValue.forEach(estado => {
      const found = filtEncCredits.filter(est => est.IdEstado.toLowerCase() == estado.toLowerCase());
      tempFilt = tempFilt.concat(found);
    });
    tempFilt.sort((a,b)=> b.NumSol - a.NumSol);
    this.api.rows = tempFilt;
    this.api.totMontoSol = 0;
    this.api.totSolAprobado = 0;
    this.api.totSolPendienteRh = 0;
    this.api.totSolPendientesDes = 0;
    this.api.totSolDesembolsado = 0;
    this.api.rows.forEach(row => {
      this.api.totMontoSol = this.api.totMontoSol + row.MontoSol
      if (row.IdEstado == "APROBADO") { this.api.totSolAprobado = this.api.totSolAprobado + 1; }
      if (row.IdEstado == "PENDIENTE-RH") { this.api.totSolPendienteRh = this.api.totSolPendienteRh + 1; }
      if (row.IdEstado == "PENDIENTE-DESEMBOLSO") { this.api.totSolPendientesDes = this.api.totSolPendientesDes + 1; }
      if (row.IdEstado == "DESEMBOLSADO") { this.api.totSolDesembolsado = this.api.totSolDesembolsado + 1; }
    });
    console.log('rows: ',this.api.rows);
    console.log('totMontoSol: ',this.api.totMontoSol);
    console.log('totSolAprobado: ',this.api.totSolAprobado);
    console.log('totSolPendienteRh: ',this.api.totSolPendienteRh);
    console.log('totSolPendientesDes: ',this.api.totSolPendientesDes);
    console.log('totSolDesembolsado: ', this.api.totSolDesembolsado);
  }

  estadosSelect(event) {
    this.api.estadosSelectValue = event.detail.value;
    console.log('Estados select: ', this.api.estadosSelectValue);
    this.filtEncCreditEstados(this.api.filtEncCred);
  }

  async fetchHisLiq(cedula: string): Promise<any[]> {
    const response: any = await this.api.req('post', 'gethisliqforcc', { cedula: cedula.trim() }, 'Consultando historial de liquidaciones...');
    
    return Array.isArray(response) ? [...response] : [];
  }
}